import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Mail from "@mui/icons-material/Mail";
import "../assets/styles/Main.scss";

function Main() {
  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img
            src="https://i.postimg.cc/Rh6thgHS/avatartion.png"
            alt="Avatar"
          />
        </div>
        <div className="content">
          <div className="social_icons">
            <a
              href="https://github.com/quamnana"
              target="_blank"
              rel="noreferrer"
            >
              <GitHubIcon />
            </a>
            <a
              href="https://www.linkedin.com/in/nana-gyambrah-5736911a8/"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon />
            </a>
            <a
              href="mailto:quamgyambrah@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              <Mail />
            </a>
          </div>
          <h1>Hi, I'm Nana 👋</h1>
          <p>A Software Engineer crafting scalable web applications,</p>
          <p>decentralized solutions, and AI-powered systems. 🚀</p>

          <div className="mobile_social_icons">
            <a
              href="https://github.com/quamnana"
              target="_blank"
              rel="noreferrer"
            >
              <GitHubIcon />
            </a>
            <a
              href="https://www.linkedin.com/in/nana-gyambrah-5736911a8/"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon />
            </a>
            <a
              href="mailto:quamgyambrah@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              <Mail />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
